<template>
  <el-drawer size="50%" title="福利日设置" :visible.sync="drawer">
    <div class="container">
      <el-form :inline="true">
        <el-form-item label="状态">
          <el-select v-model="status" placeholder="状态" clearable>
            <el-option label="上架中" :value="1"></el-option>
            <el-option label="下架" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList(1)">搜索</el-button>
          <el-button type="success" @click="openAdd">新增规则</el-button>
        </el-form-item>
      </el-form>
      <auto-table
        :DataList="DataList"
        :option="Option"
        :total="Total"
        @changePage="getList"
      >
        <template #status="{ row }">
          <div>
            <el-tag v-if="row.status === 1">上架中</el-tag>
            <el-tag type="danger" v-if="row.status === 2">下架</el-tag>
          </div>
        </template>
        <template #time="{ row }">
          <div>开始：{{ row.start_time }}</div>
          <div>结束：{{ row.end_time }}</div>
        </template>
        <template #handler="{ row }">
          <div>
            <el-button type="primary" size="small" @click="openEdit(row)"
              >修改</el-button
            >
            <el-button
              v-if="row.status === 1"
              type="primary"
              size="small"
              @click="updateStatus(row, 2)"
              >下架</el-button
            >
            <el-button
              v-if="row.status === 2"
              type="primary"
              size="small"
              @click="updateStatus(row, 1)"
              >上架</el-button
            >
          </div>
        </template>
      </auto-table>

      <editBenefit ref="add" @success="getList(1)"></editBenefit>
    </div>
  </el-drawer>
</template>

<script>
import editBenefit from "./editBenefit.vue";

export default {
  components: {
    editBenefit,
  },
  props: {
    venue: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "title" },
        { name: "折扣", value: "benefit_ratio" },
        { name: "状态", value: "status", type: "custom" },
        { name: "时间", value: "time", type: "custom" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      drawer: false,
      card: {},
    };
  },

  methods: {
    open(v) {
      this.card = v;
      this.drawer = true;
      this.getList(1);
    },
    openAdd() {
      this.$refs.add.open({}, this.card);
    },
    openEdit(row) {
      this.$refs.add.open(row, this.card);
    },

    // 更新设备
    updateStatus(row, status) {
      let url = "user/benefitDay/update";
      this.$axios
        .post(url, {
          id: row.id,
          status: status,
        })
        .then((res) => {
          this.getList();
        });
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/benefitDay/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          venue_id: this.card.venue_id,
          card_id: this.card.id
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>